"use client";

import { useRouter } from 'next/navigation';
import Image from "next/image";
export default function HandleClickHome() {
  const router = useRouter();
  //console.log("Click the logo");

  const handleClick = () => {
    router.push(`/`);
  };
  return <Image src='/assets/return.svg' alt="Return" width={20} height={20} onClick={handleClick} style={{
    cursor: 'pointer'
  }} data-sentry-element="Image" data-sentry-component="HandleClickHome" data-sentry-source-file="ClickHome.tsx"></Image>;
}